import React from "react";
import { AuthContext } from "../../lib/AuthContext";
import ParentComponent from "../../lib/ParentComponent";
import firebase, { auth } from "../../lib/firebase";
import ar from "../../locale";
import DatePicker from "react-datepicker";
import { deleteUrl } from "../../constants";
import moment from "moment";
import "moment/locale/ar";
import "react-datepicker/dist/react-datepicker.css";

export default class MatchesTableRow extends ParentComponent {
  static contextType = AuthContext;

  constructor(props, context) {
    super(props, context);
    this.state = {
      user: context.user,
      token: null,
      deleting: false,
      updating: false,
      match: this.props.match,
    };
    this.matchRef = firebase.database().ref("matches/" + this.props.match.key);
  }

  componentDidMount() {
    super.componentDidMount();
    auth.currentUser.getIdToken().then((token) => {
      this.state.token = token;
      this.updateState();
    });
    if (this.props.match.started_timestamp) {
      let on = moment(this.props.match.started_timestamp);
      on.locale("en");
      this.state.started_timestamp = on.toDate();
    }
    if (this.props.match.finished_timestamp) {
      let on = moment(this.props.match.finished_timestamp);
      on.locale("en");
      this.state.finished_timestamp = on.toDate();
    }
    this.updateState();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  updateState = () => {
    this.setState((prev) => {
      return { ...prev };
    });
  };

  handleChange = (key, e) => {
    this.state.match[key] = e.target.checked;
    this.updateState();
  };

  handleChangeDate = (key, value) => {
    this.state[key] = value;
    let on = moment(value);
    on.locale("en");
    this.state.match[key] = on.toDate().getTime();
    this.updateState();
  };

  handleScoreChange = (key, e) => {
    this.state.match[key] = e.target.value;
    this.updateState();
  };

  deleteConfirmation = () => {
    this.confirm(null, this.onDelete.bind(this));
  };

  onDelete = () => {
    let { match } = this.state;
    this.state.deleting = true;
    this.updateState();
    fetch(deleteUrl, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.state.token,
      },
      body: JSON.stringify({
        path: "matches/" + match.key,
      }),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        this.state.deleting = false;
        this.updateState();
        if (this.props.onDelete) {
          this.props.onDelete(match);
        }
      })
      .catch((error) => {
        this.showError(error.message);
        this.state.deleting = false;
        this.updateState();
      });
  };

  onUpdate = () => {
    this.state.updating = true;
    this.updateState();
    this.matchRef
      .update({
        ...this.state.match,
      })
      .then((res) => {
        this.showSuccess(ar.operation_successful);
        this.state.updating = false;
        this.updateState();
      })
      .catch((error) => {
        this.showError(error.message);
        this.state.updating = false;
        this.updateState();
      });
  };

  render() {
    let { match } = this.state;
    let mt = moment(match.on);
    mt.locale("ar");
    return (
      <div className="row match-row align-items-center pb-3 border-bottom">
        <div className="col-md-6 mt-2">
          <div className="row">
            <div className="col-12 ltr mt-2 text-center">
              {ar.kickoff} - {mt.format("lll")}
            </div>
          </div>
          <div className="row">
            <div className="col-6 ltr mt-2">
              <div className="d-flex flex-row align-items-center">
                {match.team1_avatar && (
                  <img
                    src={match.team1_avatar}
                    className="avatarc"
                    width="30"
                    height="30"
                    alt="avatar"
                  />
                )}
                <span className="pl-1 pr-1">{match.team1_name}</span>
              </div>
              <div className="form-group mb-0 mt-2">
                <input
                  disabled={!match.started}
                  value={match.team1_score || ""}
                  onChange={this.handleScoreChange.bind(this, "team1_score")}
                  type="number"
                  className="form-control w-50"
                  id="points"
                  placeholder={ar.score}
                />
              </div>
            </div>
            <div className="col-6 mt-2">
              <div className="d-flex flex-row align-items-center">
                {match.team2_avatar && (
                  <img
                    src={match.team2_avatar}
                    className="avatarc"
                    width="30"
                    height="30"
                    alt="avatar"
                  />
                )}
                <span className="pl-1 pr-1">{match.team2_name}</span>
              </div>
              <div className="form-group mb-0 mt-2">
                <input
                  disabled={!match.started}
                  value={match.team2_score || ""}
                  onChange={this.handleScoreChange.bind(this, "team2_score")}
                  type="number"
                  className="form-control w-50"
                  id="points"
                  placeholder={ar.score}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 ltr mt-2 text-center">
              {this.state.deleting && (
                <button
                  name="save"
                  className="btn btn-sm mr-1 ml-1 btn-danger btn-rounded"
                >
                  <span
                    className="d-inline-block spinner-border spinner-border-sm text-white"
                    role="status"
                  ></span>
                </button>
              )}
              {!this.state.deleting && (
                <button
                  name="save"
                  className="btn btn-sm mr-1 ml-1 btn-danger btn-rounded"
                  onClick={this.deleteConfirmation}
                >
                  {ar.delete}
                </button>
              )}
              {!this.state.updating && (
                <button
                  name="save"
                  className="btn btn-sm mr-1 ml-1 btn-info btn-rounded"
                  onClick={this.onUpdate}
                >
                  {ar.save}
                </button>
              )}
              {this.state.updating && (
                <button
                  name="save"
                  className="btn btn-sm mr-1 ml-1 btn-info btn-rounded"
                >
                  <span
                    className="d-inline-block spinner-border spinner-border-sm text-white"
                    role="status"
                  ></span>
                </button>
              )}
            </div>
          </div>
        </div>
        <div className="col-md-6 mt-2">
          <div className="row">
            <div className="col-12 mt-2">
              <input
                type="checkbox"
                className="custom-control-input cursor-pointer"
                id={match.key + "started"}
                name="radio-stacked"
                checked={match.started}
                onChange={this.handleChange.bind(this, "started")}
              />
              <label
                className="custom-control-label"
                htmlFor={match.key + "started"}
              >
                <span className="pr-4">{ar.match_started}</span>
              </label>
            </div>
            <div className="col-12 mt-2">
              <DatePicker
                disabled={!match.started}
                selected={this.state.started_timestamp}
                onChange={this.handleChangeDate.bind(this, "started_timestamp")}
                dateFormat="MMMM d, yyyy h:mm aa"
                placeholderText={ar.start_time}
                showTimeSelect
              />
            </div>
          </div>
          <div className="row">
            <div className="col-12 mt-2">
              <input
                type="checkbox"
                className="custom-control-input cursor-pointer"
                id={match.key + "finished"}
                name="radio-stacked"
                checked={match.finished}
                onChange={this.handleChange.bind(this, "finished")}
              />
              <label
                className="custom-control-label"
                htmlFor={match.key + "finished"}
              >
                <span className="pr-4">{ar.match_completed}</span>
              </label>
            </div>
            <div className="col-12 mt-2">
              <DatePicker
                disabled={!match.finished}
                selected={this.state.finished_timestamp}
                onChange={this.handleChangeDate.bind(
                  this,
                  "finished_timestamp"
                )}
                dateFormat="MMMM d, yyyy h:mm aa"
                placeholderText={ar.start_time}
                showTimeSelect
              />
            </div>
          </div>
        </div>
        {/* <div className="col-sm-1 mt-2">
                    {this.state.deleting && (
                        <span className="d-inline-block spinner-border spinner-border-sm text-danger" role="status"></span>
                    )}
                    {!this.state.deleting && (
                        <i className="fa fa-trash text-danger cursor-pointer" title={ar.delete} onClick={this.onDelete.bind(this,match)}></i>
                    )}
                </div> */}
      </div>
    );
  }
}
